import { generatePath, useHistory } from "react-router-dom";

import {
  DOCUMENT_DELETE_CONFIRMATION_FULL_PATH,
  DOCUMENT_DETAILS_FULL_PATH,
  DOCUMENT_PREVIEW_FULL_PATH,
  DOCUMENT_UPLOAD_MODAL_PATH,
} from "../paths";
import { useFileUploaderContext } from "../useFileUploaderContext";
import { useRequirementDetailsContext } from "./useRequirementDetailsContext";

export function useDocumentDetailsActions() {
  const { requirement: workerRequirement } = useRequirementDetailsContext();
  const { documents, requirementId } = workerRequirement;
  const document = documents?.[0];
  const { id: documentId = "" } = document ?? {};
  const { uploadedFiles } = useFileUploaderContext();

  const history = useHistory();

  const uploadDocument = () => {
    if (uploadedFiles?.length > 0) {
      history.replace(
        generatePath(DOCUMENT_PREVIEW_FULL_PATH, {
          requirementId,
        })
      );
    } else {
      history.replace(
        generatePath(`${DOCUMENT_DETAILS_FULL_PATH}/${DOCUMENT_UPLOAD_MODAL_PATH}`, {
          requirementId,
        })
      );
    }
  };

  const deleteDocument = async () => {
    history.replace(
      generatePath(`${DOCUMENT_DELETE_CONFIRMATION_FULL_PATH}`, {
        requirementId,
        documentId,
      })
    );
  };

  return {
    uploadDocument,
    deleteDocument,
  };
}
